export const USE_MQTT = process.env.REACT_APP_USE_MQTT === 'true';
export const MQTT_URL = process.env.REACT_APP_MQTT_URL;
export const MQTT_USERNAME = process.env.REACT_APP_MQTT_USERNAME;
export const MQTT_PASSWORD = process.env.REACT_APP_MQTT_PASSWORD;

/**
 * Builds the telemetry topic for a given device UUID
 * @param deviceUuid - The device UUID
 * @returns The MQTT topic string: drones/{deviceUuid}/telemetry
 */
export const buildTelemetryTopic = (deviceUuid: string): string => {
  return `drones/${deviceUuid}/telemetry`;
};
